import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Layout from '~/src/layout/_layout';
import { getTvPackets, getBanner } from '~/src/api/channels';
import { getTvChannels } from '~/src/api/content/channels/channels';
import { getTvChannelPackages } from '~/src/api/content/channels/packages';
import { getSalePackages, EExpand } from '~/src/api/content/sale-packages';
import DomruChannels from '~/src/layout/domru-tv/channels';
import DomruChannelsAuth from '~/src/layout/domru-tv/channelsAuth';
import * as base from '~/src/helpers/basePageFunc';
import { getChannelThemes } from '~/src/store/actions/bundles';

class ChannelsPage extends Component {
    static propTypes = {
        city: PropTypes.object,
        hostname: PropTypes.string,
    };

    static async getInitialProps(options) {
        const { hostname, headerHost } = await base.initialProps(options);
        const { getState, dispatch } = options.store;
        const state = getState();
        const { currentCity } = state.city;
        const { accessToken, billingDomain } = state.auth;

        const { domain } = currentCity;
        const notThemes = !state.bundles?.channelThemes.length;

        let tvPackets, bannerInfo;
        if (accessToken) {
            const [packetsResp, bannerResp] = await Promise.all([
                getTvPackets({ cityDomain: billingDomain || domain, accessToken }),
                getBanner(billingDomain || domain),
            ]);
            tvPackets = packetsResp;
            bannerInfo = bannerResp.data;
        }

        const channelProps = {
            channels: [],
            themedChannels: {},
            themedChannelsArray: [],
        };

        const [response, salePackages, channelPackages] = await Promise.all([
            getTvChannels(domain),
            getSalePackages(domain, [EExpand.desc]),
            getTvChannelPackages(domain),
            notThemes ? dispatch(getChannelThemes()) : Promise.resolve(true),
        ]);

        if (response.status === 200) {
            const parsed = response.data.reduce((result, channel) => {
                result[channel.themeId] = result[channel.themeId] || {
                    id: channel.themeId,
                    name: channel.themePlural,
                    weight: channel.themeWeight,
                    channels: []
                };
                result[channel.themeId].channels.push(channel);
                return result;
            }, {});
            Object.assign(channelProps, {
                channels: response.data,
                themedChannels: parsed,
                themedChannelsArray: Object.values(parsed).sort((a, b) => a.weight - b.weight)
            });
        }

        const parseSalePackages = salePackages.map(item => ({
            id: item.sale_package_id,
            title: item.description ? item.description.title : item.internet,
            price: item.price,
            channelsCount: item.sd_count + item.hd_count,
            alias: item.description ? item.description.alias : '',
        }));

        channelProps.channels.forEach((channel) => {
            channel.salePackages = parseSalePackages.filter(bundle => channel.salePackageIds && channel.salePackageIds.includes(bundle.id));
            channel.channelPackages = channelPackages.data.filter(bundle => channel.channelPackageIds && channel.channelPackageIds.includes(bundle.id));
        });

        return {
            hostname,
            relCanonical: headerHost,
            themes: getState().bundles.channelThemes,
            tvPackets,
            bannerInfo,
            ...channelProps,
        };
    }

    render() {
        const { city, hostname, relCanonical, isAuth, themes, themedChannels, themedChannelsArray, channels, tvPackets, bannerInfo } = this.props;

        const cityText = city.cityIn;

        return (
            <Layout
                title={`Полный список каналов цифрового и кабельного телевидения от Дом.ru в ${cityText}`}
                description={`Провайдер Дом.ru предлагает ознакомиться с полным списком доступных для подключения цифровых каналов в ${cityText}. Узнайте подробнее на нашем сайте или по ☎ ${city.phone}`}
                hostname={hostname}
                relCanonical={`https://${relCanonical}/domru-tv/channel`}
                city={city}
                withMenu={true}
                withFooter={true}
                withChat={true}
            >
                {isAuth
                    ?   <DomruChannelsAuth
                            tvPackets={tvPackets}
                            bannerInfo={bannerInfo}
                        />
                    :   <DomruChannels
                            themes={themes}
                            channels={channels}
                            themedChannels={themedChannels}
                            themedChannelsArray={themedChannelsArray}
                        />
                }
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    city: state.city.currentCity,
    isAuth: state.auth.isAuth,
});

export default connect(mapStateToProps)(ChannelsPage);
